export const roleNames = {
  billing: 'Billing',
  paymentMethod: 'PaymentMethod',
  quote: 'Quote',
  serviceHistory: 'ServiceHistory',
  surcharging: 'Surcharging',
};
